import { IIconProps } from '../../types/IconProps.interface'

export const IconLink = ({ color = 'white' }: IIconProps) => {
  return (
    <svg className='w-full' fill='none' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.5 6.50001V1.50001M16.5 1.50001H11.5M16.5 1.50001L9 9M7.33333 1.5H5.5C4.09987 1.5 3.3998 1.5 2.86503 1.77248C2.39462 2.01217 2.01217 2.39462 1.77248 2.86503C1.5 3.3998 1.5 4.09987 1.5 5.5V12.5C1.5 13.9002 1.5 14.6002 1.77248 15.135C2.01217 15.6054 2.39462 15.9878 2.86503 16.2275C3.3998 16.5 4.09987 16.5 5.5 16.5H12.5C13.9002 16.5 14.6002 16.5 15.135 16.2275C15.6054 15.9878 15.9878 15.6054 16.2275 15.135C16.5 14.6002 16.5 13.9002 16.5 12.5V10.6667'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}
